/**
 * Identify traits that must not be replayed from Segment's `ajs_user_traits` cache.
 *
 * - `active_externship_progress_percentage` was written by removed pre-May frontend code
 * - Route-scoped externship IDs were previously merged into identify and then persisted
 */
export const LEGACY_IDENTIFY_TRAIT_KEYS = [
  'active_externship_progress_percentage',
  'externship_id',
  'externship_module_id',
  'externship_step_id',
  'externship_substep_id',
] as const;

export type LegacyIdentifyTraitKey = (typeof LEGACY_IDENTIFY_TRAIT_KEYS)[number];

export interface StripLegacyTraitsResult {
  removedCount: number;
  traits: Record<string, unknown>;
}

/**
 * Returns a shallow copy of `traits` without denylisted keys.
 * Does not mutate the input.
 */
export function stripLegacyTraits(
  traits: Record<string, unknown>,
  keys: readonly string[] = LEGACY_IDENTIFY_TRAIT_KEYS,
): StripLegacyTraitsResult {
  const result: Record<string, unknown> = { ...traits };
  let removedCount = 0;

  for (const key of keys) {
    if (Object.hasOwn(result, key)) {
      delete result[key];
      removedCount += 1;
    }
  }

  return { traits: result, removedCount };
}
